export default __webpack_public_path__ + "static/media/Thingamabobs.184ee048.png";